module.exports = __webpack_public_path__ + "static/rindle-d3a27118b94fa1f38a86aefaa077cb85.png";